import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ClipboardModule } from "@angular/cdk/clipboard";

import{ProfileComponent} from '../app/components/profile/profile.component'
import { AboutmeComponent } from './components/aboutme/aboutme.component';
import { CvComponent } from './components/cv/cv.component';
import { ProjectsComponent } from './components/projects/projects.component';
import { PublicationsComponent } from './components/publications/publications.component';
import {NgPipesModule} from 'ngx-pipes';

import { ProjectDetailsComponent } from './components/projects/project-details/project-details.component';
import { HProfileComponent } from './components/profile/h-profile/h-profile.component';
import { NewsComponent } from './components/news/news.component';
import { PubWrapperComponent } from './components/publications/pub-wrapper/pub-wrapper.component';

import {AnalyticsService} from '../app/services/analytics.service/analytics.service';
import { TeachingComponent } from './components/teaching/teaching.component';
import { EconResearchComponent } from './components/econ-research/econ-research.component'
@NgModule({
  declarations: [
    AppComponent,
    ProfileComponent,
    AboutmeComponent,
    CvComponent,
    ProjectsComponent,
    PublicationsComponent,
    ProjectDetailsComponent,
    HProfileComponent,
    NewsComponent,
    PubWrapperComponent,
    TeachingComponent,
    EconResearchComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    ClipboardModule,
    NgPipesModule
    
  ],
  providers: [AnalyticsService],
  bootstrap: [AppComponent]
})
export class AppModule { }
